jQuery(document).ready(function($) {
  $('.how-to-get__tabs li').click(function() {
    $(this).addClass('active').siblings().removeClass('active');
    $('.how-to-get__tab-content').removeClass('active');
    $('.how-to-get__tab-content').eq($(this).index()).addClass('active');
  });

  const ranges = document.querySelectorAll('.calculator__input-range');

  const updateRangeProgress = (range) => {
    const min = Number(range.min || 0);
    const max = Number(range.max || 100);
    const value = Number(range.value || min);
    const denom = max - min;

    const progress = denom <= 0 ? 0 : ((value - min) / denom) * 100;
    const clamped = Math.min(100, Math.max(0, progress));

    range.style.setProperty('--range-progress', `${clamped}%`);
  };

  ranges.forEach((range) => {
    updateRangeProgress(range);
    range.addEventListener('input', () => updateRangeProgress(range));
    range.addEventListener('change', () => updateRangeProgress(range));
  });

  // Calculator logic
  const calculator = document.querySelector('.calculator');
  if (calculator) {
    const inputs = calculator.querySelectorAll('.calculator__input');
    const amountInput = inputs[0]?.querySelector('.calculator__input-range');
    const termInput = inputs[1]?.querySelector('.calculator__input-range');
    const amountValueEl = inputs[0]?.querySelector('.calculator__input-value');
    const termValueEl = inputs[1]?.querySelector('.calculator__input-value');
    const resultValueEl = calculator.querySelector('.calculator__result-value');

    // Format number to Indian rupee format (1,00,000)
    const formatIndianRupee = (num) => {
      const str = Math.round(num).toString();
      let result = '';
      let count = 0;

      for (let i = str.length - 1; i >= 0; i--) {
        if (count === 3 || (count > 3 && (count - 3) % 2 === 0)) {
          result = ',' + result;
        }
        result = str[i] + result;
        count++;
      }

      return result;
    };

    const updateCalculator = () => {
      if (!amountInput || !termInput) return;

      const amount = Number(amountInput.value);
      const term = Number(termInput.value);
      const installment = term > 0 ? amount / term : 0;

      if (amountValueEl) {
        amountValueEl.textContent = `₹ ${formatIndianRupee(amount)}`;
      }

      if (termValueEl) {
        termValueEl.textContent = `${term} months`;
      }

      if (resultValueEl) {
        resultValueEl.textContent = `from ₹ ${formatIndianRupee(installment)} x ${term} months`;
      }
    };

    // Initial update
    updateCalculator();

    // Listen for changes
    if (amountInput) {
      amountInput.addEventListener('input', updateCalculator);
      amountInput.addEventListener('change', updateCalculator);
    }
    if (termInput) {
      termInput.addEventListener('input', updateCalculator);
      termInput.addEventListener('change', updateCalculator);
    }
  }
});